import React from "react";
import Modal from "react-bootstrap/Modal";
import "../App.css";

const AnalysisTypesModal = ({ show, handleClose, Id, header, types }) => {

  return (
    <Modal show={show} size="md" onHide={() => handleClose("Cancel", Id)}>
      <Modal.Header className="bg-danger text-white">
        <h3>{header}</h3>
      </Modal.Header>
      <Modal.Body>
        <h5 class="modalWrap">{types}</h5>
        <br></br>
        <br></br>
        <div className="row">
          <div className="col">
            <button
              className="btn btn-lg btn-danger"
              onClick={() => handleClose("Cancel")}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AnalysisTypesModal;
